import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    detailChannel = new Subject();
    updateChannel = new Subject();
    checkDateChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.checkDateChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchUpdate = async (query) => {
        try {
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchCheckDate = async (query) => {
        try {
            this.checkDateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheckDate(query).then((result) => {
                this.checkDateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkDateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
}

export default UpdateBloc